import { render, staticRenderFns } from "./manage-po-types.vue?vue&type=template&id=185857ae&scoped=true&"
import script from "./js/manage-po-types.js?vue&type=script&lang=js&"
export * from "./js/manage-po-types.js?vue&type=script&lang=js&"
import style0 from "./manage-po-types.vue?vue&type=style&index=0&id=185857ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185857ae",
  null
  
)

export default component.exports